
import _ from "lodash";
import loadStaffAvailabilities from "../utils/availabilityHelper";
import { postMessageService } from "@/modules/common/services";

const initialState = {
  uid: null,
  action: null,
  reason: null,
  payload: {},
  evidence: [],
  isClear: false,
};

const state = { ...initialState };

const mutations = {
  clearScheduleRecommendation(state) {
    state = { ...initialState };
    state.isClear = true;
  },
  setAiRecommendation(state, recommendation) {
    state.uid = recommendation.uid;
    state.action = recommendation.action;
    state.reason = recommendation.display.reason;
    state.display = recommendation.display;
    state.payload = recommendation.payload;
    state.evidence = recommendation.evidence;
  },
  updateUseAiRecommendationPaylod(state, payload) {
    state.payload = payload;
  },
};

const actions = { 
  async fetchScheduleRecommendation({ commit, dispatch, state, rootGetters }, { clientUid, matterUid, staff }) {
    try {
      if (state.isClear) {
        return;
      }
      await dispatch('bizAiModule/fetchRecommendations', {dismissed: false, clientUid, matterUid}, {root: true});

      const aiRecommendation = rootGetters['bizAiModule/getRecommendationByMatter'](matterUid);
      const aiScheduleRecommendation = aiRecommendation?.actions.find(a => a.action === 'schedule');

      commit('clearScheduleRecommendation');
      if (aiScheduleRecommendation) {
        commit('setAiRecommendation', aiScheduleRecommendation);

        const appointment = aiScheduleRecommendation.payload;
        // TODO - remove this due to timezone bug
        // const staffAvailability = await dispatch('checkStaffAvailability', {recommendation: aiScheduleRecommendation, staff});
        const staffAvailability = { checkStaffAvailability: {
          availability: true,
          startTime: appointment.recommended_start_time,
          messgage: 'Staff is available for the suggested booking time',
        },};
        const newAppointmentDetails = { ...state.payload, ...staffAvailability};
        commit('updateUseAiRecommendationPaylod', newAppointmentDetails);
      }
    } catch (error) {
      console.log('Error getting the AI schedule recommendation:', error);
      commit('clearScheduleRecommendation');
    }
  },
  async checkStaffAvailability({}, { recommendation, staff }) {
    const staffUid = staff?.uid || null;
    const appointment = recommendation.payload;
    if (!staffUid || !appointment?.recommended_start_time || !appointment?.service_uid || !appointment?.duration) {
      return {
        checkStaffAvailability: {
          availability: false, 
        }
      };
    }

    const startTime = new Date(appointment.recommended_start_time);
    const endTime = new Date(startTime.getTime() + (appointment.duration * 60000));
    const satffAvailability = await loadStaffAvailabilities(appointment.service_uid, appointment.recommended_start_time, staff);

    const foundTime = satffAvailability[staffUid].some(availability => availability.startTime <= startTime && availability.endTime >= endTime)
    console.log('checkStaffAvailability status', foundTime);
  
    if (!foundTime) {
      return {
        checkStaffAvailability: {
          availability: false,
          messgage: 'Staff is not available for the suggested booking time',
        }
      };
    }

    return {
      checkStaffAvailability: {
        availability: true,
        startTime: appointment.recommended_start_time,
        // endTime: '2025-01-05T13:45:00+02:00',
        messgage: 'Staff is available for the suggested booking time',
      },
    };
  },
  clearAiScheduleRecommendation({commit, dispatch}) {
    commit('clearScheduleRecommendation');
    // TODO - should get action.uid
    dispatch('bizAiModule/clearRecommendations', null, {root: true});
  },
  async isSettingEnableAiScheduling({}) {
    try {
      postMessageService.post('povMessage', {
        eventName: 'update-store',
        payload: { type: 'BizaiStore/fetchStaffAiSettings', payload: {} }
      });
      const staffAiSettings = await postMessageService.getDataFromPOVStore('BizaiStore/staffAiSettings');
      const aiRecommendationSettings = staffAiSettings.data?.aiRecommendations;
      return aiRecommendationSettings?.enabled && aiRecommendationSettings.subOptions.scheduling;
    } catch (error) {
      console.log('Error getting the AI scheduling settings:', error);
      return false;
    }
  },
};

const getters = {
  getScheduleRecommendation: (state) => state,
  getSaffAcialability: (state) => state.payload.checkStaffAvailability,
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}; 
